import api from './api';
import type { User, UserPreferences, CreateUserRequest, UpdateUserRequest } from '../types';

export const usersService = {
  async list(): Promise<User[]> {
    const { data } = await api.get<{ success: boolean; data: { users: User[] } }>('/users');
    return data.data.users;
  },

  async getAll(): Promise<User[]> {
    return this.list();
  },

  async getById(id: string): Promise<User> {
    const { data } = await api.get<{ success: boolean; data: User }>(`/users/${id}`);
    return data.data;
  },

  async create(userData: CreateUserRequest): Promise<User> {
    const { data } = await api.post<{ success: boolean; data: { user: User } }>('/users', userData);
    return data.data.user;
  },

  async update(id: string, userData: UpdateUserRequest): Promise<User> {
    const { data } = await api.put<{ success: boolean; data: User }>(`/users/${id}`, userData);
    return data.data;
  },

  async updatePassword(id: string, password: string): Promise<void> {
    await api.put(`/users/${id}/password`, { password });
  },

  async updateStatus(id: string, banned: boolean): Promise<User> {
    const { data } = await api.put<{ success: boolean; data: User }>(`/users/${id}/status`, {
      banned,
    });
    return data.data;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/users/${id}`);
  },

  async getMyPreferences(): Promise<UserPreferences> {
    const { data } = await api.get<{ success: boolean; data: UserPreferences }>('/users/me/preferences');
    return data.data;
  },

  async updateMyPreferences(prefs: Partial<UserPreferences>): Promise<UserPreferences> {
    const { data } = await api.patch<{ success: boolean; data: UserPreferences }>('/users/me/preferences', prefs);
    return data.data;
  },
};

export default usersService;
